document.addEventListener("DOMContentLoaded", function () { /* Activate White Elements in Header */
    let lastScrollY = window.scrollY;
    function handleScroll() {
        let stickyHeaders = document.querySelectorAll('.sticky-header');

        stickyHeaders.forEach(stickyHeader => {
            if (window.scrollY > 500) {
                if (window.scrollY > lastScrollY) {
                    // Scrolling down
                    stickyHeader.classList.add('sticky');
                } else {
                    // Scrolling up
                    stickyHeader.classList.remove('sticky');
                }
            } else {
                stickyHeader.classList.remove('sticky');
            }
        });

        lastScrollY = window.scrollY;
    }
    window.addEventListener('scroll', handleScroll);


    let headers = document.querySelectorAll('header.header');
    headers.forEach( header => {
        let megaMenuItems = header.querySelectorAll('.header-menu .has-mega-menu');
        let megaMenuContainer = header.querySelector( '.header-megamenu' ); 
        let megaMenuItemsContents = header.querySelectorAll('.header-megamenu-item');
        let body = document.querySelector( 'body' ); 
        let megaSubMenuItems = header.querySelectorAll('.wt-tab-item');
        let megaSubMenuItemsContents = header.querySelectorAll('.wt-menutab-content-item');
        let hideTimeout;
        megaMenuItems.forEach(function (megaMenuItem) {
            let menuId = megaMenuItem.getAttribute('data-id');    
            var activeMegaMenu = header.querySelector('.header-megamenu-item[data-id =' + menuId + ']');  
            megaMenuItem.addEventListener('mouseenter', function (e) {
                // console.log(e);
                // activeMegaMenu = header.querySelector('.header-megamenu-item[data-id =' + menuId + ']');  
                // activeMegaMenu = e.target.closest('header.header').querySelector('.header-megamenu-item[data-id =' + menuId + ']');
                // console.log(e.target.closest('header.header').querySelector('.header-megamenu-item[data-id =' + menuId + ']'));
                // megaMenuItem.closest('header.header').classList.add('test');
                e.preventDefault();
                megaMenuItems.forEach(function (item) {
                    item.classList.remove('active');
                });
                clearTimeout(hideTimeout);
        
                if (megaMenuItem.classList.contains('has-mega-menu')) {
                    // Remove active states from all mega menu items and their content
                    megaMenuItemsContents.forEach(function (megaMenuItemsContent) {
                        megaMenuItemsContent.classList.remove('show');
                    });
        
                    body.classList.add('open-megamenu');
                    header.classList.add('active');
                    megaMenuItem.classList.add('active');
        
                    let activeMegaMenuAllContents = activeMegaMenu.querySelectorAll('.wt-menutab-content-item');
                    activeMegaMenuAllContents.forEach(function (activeMegaMenuAllContent) {
                        activeMegaMenuAllContent.classList.remove('show');
                    });
        
                    // Set the first .wt-tab-item as active and show its content
                    let firstTabItem = activeMegaMenu.querySelector('.wt-tab-item:first-child');
                    if (firstTabItem) {
                        megaSubMenuItems.forEach(function (subItem) {
                            subItem.classList.remove('active');
                        });
                        firstTabItem.classList.add('active');
                        let firstTabId = firstTabItem.getAttribute('data-id');
                        let firstTabContent = header.querySelector('.header-tab-content-item[data-id =' + firstTabId + ']');
                        if (firstTabContent) {
                            firstTabContent.classList.add('show');
                        }
                    }
        
                    activeMegaMenu.classList.add('show');
                } else {
                    body.classList.remove('open-megamenu');
                    headers.forEach( header => {
                        header.classList.remove('active');
                    });
                }
            });
        
            megaMenuItem.addEventListener('mouseleave', function (e) {
                hideTimeout = setTimeout(function () {
                    // Hide mega menu content and remove active states
                    megaMenuItem.classList.remove('active');
                    if (activeMegaMenu) {
                        activeMegaMenu.classList.remove('show');
                    }
        
                    body.classList.remove('open-megamenu');
                    headers.forEach( header => {
                        header.classList.remove('active');
                    });
                }, 300); // 300ms delay before hiding
            });
        
            if (activeMegaMenu) {
                activeMegaMenu.addEventListener('mouseenter', function (e) {
                    clearTimeout(hideTimeout);
                });
        
                activeMegaMenu.addEventListener('mouseleave', function (e) {
                    hideTimeout = setTimeout(function () {
                        // Hide mega menu content and remove active states
                        megaMenuItem.classList.remove('active');
                        activeMegaMenu.classList.remove('show');
                        body.classList.remove('open-megamenu');
                        headers.forEach( header => {
                            header.classList.remove('active');
                        });
                    }, 300); // 300ms delay before hiding
                });
            }
        });    
        // Megamenu tab script    
        megaSubMenuItems.forEach( function( megaSubMenuItem ) {
            megaSubMenuItem.addEventListener( 'mouseenter', function(e){
                e.preventDefault();
                megaSubMenuItems.forEach(function(subItem){
                    subItem.classList.remove('active');
                });
                megaSubMenuItemsContents.forEach(function(megaSubMenuItemsContent){
                    megaSubMenuItemsContent.classList.remove('show');
                });
                megaSubMenuItem.classList.add('active');
                let subMenuId = megaSubMenuItem.getAttribute('data-id');
                let activeSubMegaMenu = header.querySelector('.header-tab-content-item[data-id =' + subMenuId + ']');
                activeSubMegaMenu.classList.add('show');
            });
        });
    });

    // //Close Mega menu
    // let closeMegaMenu = document.getElementById('close-megamenu');
    // closeMegaMenu.addEventListener('click', function(){
    //     body.classList.remove('open-megamenu');
    // });

    /**
     * Mobile Menu Script
     */
    //Toggle menu for responsive
    document.querySelectorAll(".header-mobile").forEach(function(mobileMenu){
        mobileMenu.querySelector('.header-mobile-ham').addEventListener("click", function() {
            var parent = mobileMenu.querySelector('.header-mobile-toggle');
            if (parent) {
                parent.classList.toggle('active');
            }
            var body = document.querySelector('body');
            // if (body.classList.contains('stop-scroll')) {
            //     // body.classList.remove('stop-scroll');
            //     // lenis = lenisScroll();
            // }
            // else{                
            //     // body.classList.add('stop-scroll');
            //     // lenis.destroy();
            // }
            this.classList.toggle("is-active");
        });
    });
    // Add toggle menu for sub menu
    var mobileMenus = document.querySelectorAll('.header-mobile-menu');
    if( mobileMenus.length ){
        mobileMenus.forEach(function(menu) {
            var menuItemsWithChildren = menu.querySelectorAll('.has-sub-menu');
            menuItemsWithChildren.forEach(function(menuItem) {
                var submenuArrow = document.createElement('span');
                submenuArrow.className = 'wt-submenu-arrow';
                menuItem.appendChild(submenuArrow);
            });
        });
    }    
    var mobileMenusToggle = document.querySelectorAll('.header-mobile-menu .wt-submenu-arrow');
    if( mobileMenusToggle.length ){
        mobileMenusToggle.forEach(function(mobileMenusToggleItem) {
            // toggleMobileSubMenu(mobileMenusToggleItem);
            mobileMenusToggleItem.addEventListener('click', function() {
                let submenu = this.previousElementSibling;
                submenu.classList.toggle('show');
                let childSubMenus = submenu.querySelectorAll('.sub-menu');
                if( childSubMenus. length ){
                    childSubMenus.forEach(function(childSubMenu) {
                        childSubMenu.classList.remove('show');
                    });
                }
            });
        });
    }

    /**
     * Tab Content
     */    
    let wtTabs = document.querySelectorAll( '.wt-tab' );
    wtTabs.forEach( function(wtTab){
        let tabTriggers = wtTab.querySelectorAll( '.wt-tab__title' );
        if( tabTriggers.length ){
            let tabContentItems = wtTab.querySelectorAll( '.wt-tab-content-item' );
            console.log(tabContentItems);
            tabTriggers.forEach( function(tabTrigger){
                let tabId = tabTrigger.getAttribute('data-id');
                tabTrigger.addEventListener('click', function(){
                    tabTriggers.forEach( function(resetTab){
                        resetTab.classList.remove('active');
                    });
                    tabContentItems.forEach( function(resetTab){
                        resetTab.classList.remove('show');
                    });
                    let activeTabContent = document.getElementById(tabId);
                    tabTrigger.classList.add('active');
                    activeTabContent.classList.add('show');
                });
            });
        }
    });

    
    /**
     * Faq Toggle
     */    
    let faqToggleWrap = document.querySelectorAll( '.faq' );
    faqToggleWrap.forEach( function(faqToggle){
        let faqToggleItems = faqToggle.querySelectorAll( '.faq-content-item' );
        faqToggleItems.forEach( function(faqToggleItem){
            faqToggleItem.querySelector('.faq-content-item-title').addEventListener('click', function(){
                let contentToggle = faqToggleItem.querySelector('.faq-content-item-content');
                faqToggleItems.forEach( function(faqToggleItemCheck){
                    if (faqToggleItemCheck.classList.contains('toggled')) {
                        faqToggleItemCheck.classList.remove('toggled');
                        let faqToggleItemCheckContent = faqToggleItemCheck.querySelector('.faq-content-item-content');
                        collapseElement(faqToggleItemCheckContent, 250);
                    }
                    else if (faqToggleItem == faqToggleItemCheck){
                        expandElement(contentToggle, 250);
                        faqToggleItem.classList.add('toggled');
                    }
                });
            });
            // if (faqToggleItem.classList.contains('toggled')) {
            //     faqToggleItem.classList.remove('toggled');
            //     collapseElement(contentToggle, 250);
            // }
            // else {
            //     expandElement(contentToggle, 250);
            //     faqToggleItem.classList.add('toggled');
            // }
        });
    });
    
    /**
     * Function for toggle down
     */
    function expandElement(element, speed, display = "block") {
        const isVisible = getComputedStyle(element).display !== 'none';
        if (!isVisible) {
            element.style.display = display;
            const height = element.scrollHeight;
            element.style.height = '0';
            element.style.overflow = 'hidden';
            const interval = 10;
            const duration = speed;
            const heightStep = height / (duration / interval);
            let currentHeight = 0;

            const timer = setInterval(() => {
                currentHeight += heightStep;
                element.style.height = currentHeight + 'px';

                if (currentHeight >= height) {
                    clearInterval(timer);
                    element.style.height = '';
                    element.style.overflow = '';
                }
            }, interval);
        }
    }
    /**
     * Function for toggle up
     */
    function collapseElement(element, speed) {
        const isVisible = getComputedStyle(element).display !== 'none';
        if (isVisible) {
        const height = element.scrollHeight;
        const interval = 10;
        const duration = speed;
        const heightStep = height / (duration / interval);
        let currentHeight = height;

        const timer = setInterval(() => {
            currentHeight -= heightStep;
            element.style.height = currentHeight + 'px';

            if (currentHeight <= 0) {
                clearInterval(timer);
                element.style.height = '';
                element.style.overflow = 'hidden';
                element.style.display = 'none';
            }
        }, interval);
        }
    }

    /**
     * Shop page
     */
    /**
     * Product color pallete
     */
    // let colorPalleteToggleItems = document.querySelectorAll('.product-color-pallete-item');
    // if( colorPalleteToggleItems.length ){
    //     colorPalleteToggleItems.forEach(function(colorPalleteToggleItem){
    //         let colorPalleteToggle = colorPalleteToggleItem.querySelector('.color-pallete-show');
    //         if( colorPalleteToggle ){
    //             colorPalleteToggle.addEventListener('click', function(){
    //                 colorPalleteToggle.parentElement.classList.toggle('toggled');
    //             });
    //         }
    //     });
    // }

    /**
     * Shop Filter toggle
     */
    let allFilters = document.querySelectorAll('.shop-filter-toggle');
    let allFiltersWraps = document.querySelectorAll('.shop-filter-toggle');
    allFilters.forEach( function( filter ) {
        filter.addEventListener('click', function(){
            let currentFilter = this;
            allFilters.forEach( function( filter ) {
                if( currentFilter != filter ){ // Check condition to hide other popup when click new filter
                    filter.parentElement.classList.remove('toggled');
                }
            });
            filter.parentElement.classList.toggle('toggled');
        });
    });
    //Custom select for Sorting to change design
    if( document.querySelector('.shop-filter-sort-option') ){
        customSelect(document.querySelector('.shop-filter-sort-option'));
    }


    let productDetailLinks = document.querySelectorAll('.wt-popup-trigger');
    let productDetailLinkCloses = document.querySelectorAll('.wt-popup-close-trigger');
    productDetailLinks.forEach( function( productDetailLink ) {
        productDetailLink.addEventListener('click', function(){
            let popupId = productDetailLink.getAttribute('data-id');
            let popupContainer = document.querySelector('.wt-popup[data-id="'+popupId+'"]');
            popupContainer.classList.add('show');
        });
    });
    
    productDetailLinkCloses.forEach(function(productDetailLinkClose){
        productDetailLinkClose.addEventListener('click', function(){
            let popupContainers = document.querySelectorAll('.wt-popup');
            popupContainers.forEach(function(popupContainer){
                popupContainer.classList.remove('show');
            });
        });
    });

    /**
     * show cart popup
     * 
     */
    let cartLinks = document.querySelectorAll('.header-cart, .header-mobile-cart');
    if( cartLinks.length ){
        cartLinks.forEach( cartLink => {
            cartLink.addEventListener('click', function(e){
                e.preventDefault();
                let cartContainer = document.querySelector('.wt-cart-sidebar');
                cartContainer.classList.add('show');
                // document.querySelector('body').classList.add('stop-scroll');
                // lenis.destroy();
            });
        });
    }
    let cartLinkRemove = document.querySelector('.wt-cart-sidebar-close');
    if( cartLinkRemove ){
        cartLinkRemove.addEventListener('click', function(e){
            e.preventDefault();
            let cartContainer = document.querySelector('.wt-cart-sidebar');
            cartContainer.classList.remove('show');
            // document.querySelector('body').classList.remove('stop-scroll');
            // lenis = lenisScroll();
        });
    }

    
    /**
     * Custom Pricing tab for Mobile
     */    
    if( window.innerWidth < 992 ){
        // let pricingFirstTab = document.querySelector( '.custom-pricing-table-tab .button:first-child' );
        // pricingFirstTab.click();
        let pricingTabs = document.querySelectorAll( '.custom-pricing-table-tab .button' );
        pricingTabs.forEach( function(pricingTab){
            pricingTab.addEventListener('click', function(){
                let contentToggleContainer = pricingTab.closest('.custom-pricing-table');
                let id = pricingTab.getAttribute('data-id');
                contentToggleContainer.classList.remove('embroidery');
                contentToggleContainer.classList.remove('bespoke');
                contentToggleContainer.classList.add(id);
                pricingTabs.forEach( function(tab){
                    tab.classList.remove('active');
                });
                pricingTab.classList.add('active');
            });
        });
    }


    //Shopify shop
    
    let sortby = document.getElementById('sort-by');
    if( sortby ){
        sortby.addEventListener('change', function() {
            let sortBy = this.value;
            let productContainer = document.querySelector('.shop-products-wrap .shop-product');
            let products = Array.from(productContainer.querySelectorAll('.product-card-list'));

            let sortFunctions = {
                'title-ascending': (a, b) => a.dataset.title.localeCompare(b.dataset.title),
                'title-descending': (a, b) => b.dataset.title.localeCompare(a.dataset.title),
                'price-ascending': (a, b) => parseFloat(a.dataset.price) - parseFloat(b.dataset.price),
                'price-descending': (a, b) => parseFloat(b.dataset.price) - parseFloat(a.dataset.price),
                'created-ascending': (a, b) => parseInt(a.dataset.date) - parseInt(b.dataset.date),
                'created-descending': (a, b) => parseInt(b.dataset.date) - parseInt(a.dataset.date),
                'best-selling': (a, b) => a.dataset.bestselling === b.dataset.bestselling ? 0 : a.dataset.bestselling === 'true' ? -1 : 1
            };

            // Check if the selected value is valid
            if (sortFunctions[sortBy]) {
                products.sort(sortFunctions[sortBy]);
                products.forEach(product => productContainer.appendChild(product));
            }
        });
    }
    
    // Select all the radio input elements for the color options
    let colorElements = document.querySelectorAll('.product-attribute-color-list input[type="radio"], .product-color-pallete-item .product-color-pallete-item-bg');
    // console.log(colorList);
    // console.log(colorElements);
    colorElements.forEach(function(colorElement) {
        // Get the color name from the radio button's value (or another attribute if used)
        let colorName = colorElement.getAttribute('data-value'); // Assuming the value of the radio is the color name

        // Find the corresponding hex code from the loaded JSON data
        let hexCode = colorList[colorName];

        // Set the background color of the radio button
        if (hexCode) {
            colorElement.style.backgroundColor = hexCode;
        } else {
            console.warn('Color not found in JSON:', colorName);
        }
    });


    
    // //Custom select for Sorting to change design
    // let stickyVariants = document.querySelectorAll('.variant-option');
    // if( stickyVariants.length ){
    //     stickyVariants.forEach( stickyVariant => {
    //         customSelect(stickyVariant);
    //     });
    // }
    // let isMobile = navigator.userAgentData.mobile;
    // if( isMobile ){
        let markerPoints = document.querySelectorAll('.wt-marker-content-item-point');
        markerPoints.forEach( markerPoint => {
            markerPoint.addEventListener('click', function(){
                markerPoints.forEach( allMarkerPoint => {
                    allMarkerPoint.parentNode.classList.add('show');
                });
                setTimeout(function(){
                    markerPoints.forEach( allMarkerPoint => {
                        allMarkerPoint.parentNode.classList.remove('show');
                    });
                }, 5000);
            });
        });
    // }

    if( document.getElementById('shopify-section-home-banner')){
        if (window.location.search.includes('srsltid')) {
            let newUrl = window.location.href.split('?')[0];
            window.history.replaceState({}, document.title, newUrl);
        }
    }

  const enquiryFormButton = document.querySelector(".form-submit");
  const enquiryForm = document.getElementById("enquiry_form");
  if (enquiryFormButton) {
    let isProcessing = false;

    enquiryFormButton.addEventListener("click", async function (event) {
      event.preventDefault();

      if (isProcessing) return; // Prevent multiple clicks
      isProcessing = true;
      enquiryFormButton.classList.add('loading');

      const formData = new FormData(enquiryForm);
      const data = {
        firstName: formData.get("contact[first_name]"),
        lastName: formData.get("contact[last_name]"),
        email: formData.get("contact[email]"),
        phone: formData.get("contact[phone_number]"),
        business_name: formData.get("contact[business_name]"),
        utm_source: formData.get("contact[utm_source]"),
        utm_medium: formData.get("contact[utm_medium]"),
        utm_campaign: formData.get("contact[utm_campaign]"),
        enquiry_message: formData.get("contact[enquiry]")
          ? formData.get("contact[enquiry]")
          : formData.get("contact[body]"),
      };

      // Validate form fields
      if (!data.firstName) {
        alert("Please enter First name.");
        isProcessing = false;
        return;
      }
      if (!data.lastName) {
        alert("Please enter Last name.");
        isProcessing = false;
        return;
      }
      if (!data.phone) {
        alert("Please enter phone number.");
        isProcessing = false;
        return;
      }
      if (!data.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
        alert("Please enter a valid email address.");
        isProcessing = false;
        return;
      }
      if (!data.enquiry_message) {
        alert("Please enter enquiry message.");
        isProcessing = false;
        return;
      }

      data.type = "live"; // Set environment type

      // Call createCustomer function
      const customerCreated = await createCustomer(data);
      if (customerCreated) {
        enquiryForm.submit();
        deleteCookie('utm_source');
        deleteCookie('utm_medium');
        deleteCookie('utm_campaign');
      }
      else{
        enquiryFormButton.classList.remove('loading');
      }

      isProcessing = false; // Reset the flag
    });

    async function createCustomer(data) {
      const apiEndpoint =
        "https://plb26okvckxaznu2esy76l3ifm0wsted.lambda-url.ap-southeast-2.on.aws";

      try {
        const response = await fetch(apiEndpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });

        const result = await response.json();
        if (response.ok) {
          console.log("Customer created successfully:", result);
          return true; // Success
        } else {
          console.error("Error creating customer:", result);
          Object.entries(result.error).forEach(([key, value]) => {
            alert(`${key}: ${value}`);
          });
          return false; // Failure
        }
      } catch (error) {
        console.error("Network error:", error);
        return false;
      }
    }
  }



  /**
   * Enquiry form
   */
  let urlParams = new URLSearchParams(window.location.search);
  let formPosted = urlParams.get("contact_posted");

  if (formPosted === "true" && typeof lenis !== 'undefined' ) {
    let target = document.querySelector("#enquiry_form");
    if (target) {
      let moq_desc = document.querySelector(".wt-enquiry-moq-desc");
      let formRows = target.querySelectorAll(".form-row");
      if (moq_desc) {
        moq_desc.style.display = "none";
      }
      formRows.forEach(row => row.style.display = "none");
      // Small delay to ensure everything is rendered  
      setTimeout(() => {
        lenis.scrollTo(target, {
          offset: -200, // Adjust offset if you have a sticky header
          duration: 1.2, // Seconds, optional
          easing: (t) => 1 - Math.pow(1 - t, 4) // optional custom easing
        });
      }, 100); 
    }
  }


  function setCookie(name, value, days) {
    let expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
  }

  function getCookie(name) {
    return document.cookie.split('; ').reduce((r, v) => {
      let parts = v.split('=');
      return parts[0] === name ? decodeURIComponent(parts[1]) : r
    }, '');
  }

  function deleteCookie(name) {
    document.cookie = name + '=; Max-Age=0; path=/';
  }

  function getQueryParam(param) {
    let urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param) || '';
  }

  // On first visit with UTM params, store them in cookies
  let utmParams = ['utm_source', 'utm_medium', 'utm_campaign'];
  utmParams.forEach(param => {
    let value = getQueryParam(param);
    if (value) {
      setCookie(param, value, 7); // Store for 7 days
    }
  });

  // Populate hidden fields from cookies  
  if (document.getElementById('utm_source') ) {
    document.getElementById('utm_source').value = getCookie('utm_source');
  }
  if (document.getElementById('utm_medium') ) {
    document.getElementById('utm_medium').value = getCookie('utm_medium');
  }
  if (document.getElementById('utm_campaign') ) {
    document.getElementById('utm_campaign').value = getCookie('utm_campaign');
  }
});